<template>
  <div>
    <base-loading :visible="isLoading" />
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-full md:col-span-2 md:col-start-11  xs:col-start-1">
        <search-input v-model="search" @search="onSearch" @clear="onSearch" />
      </div>
      <div class="col-span-full col-start-1">
        <vendors-table :items="items" @loadMore="loadMore" @sortChanged="onSortChanged" @details="onDetails"
          @updateVendor="updateVendor" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useVendors } from '../composables/use-vendors'
import { useNotifier } from '@/composables/useNotifier'
import { useNavigator } from '@/composables/useNavigator'
import VendorsTable from '../components/VendorsTable'
import BaseLoading from '@/views/app/components/BaseLoading'
import SearchInput from '@/views/app/components/SearchInput'

const { notify } = useNotifier()
const { goTo } = useNavigator()
const search = ref('')
const vendors = useVendors()
const sort = ref({})
const items = computed(() => vendors.state.items)
const currentPage = computed(() => vendors.state.currentPage)
const lastPage = computed(() => vendors.state.lastPage)
const isLoading = computed(() => vendors.state.loading)

const loadData = async (params = {}) => {
  const payload = {
    page: vendors.state.currentPage || 1,
    search: search.value,
    column: sort.value.column,
    order: sort.value.order,
    ...params
  }
  const result = await vendors.getVendors(payload)
  if (!result.success) notify({ title: 'error', text: 'message_error', color: 'danger' })
}

const loadMore = async () => {
  if (currentPage.value >= lastPage.value) return
  const newPage = vendors.state.currentPage + 1
  await loadData({ page: newPage })
}

const onSearch = async () => {
  await loadData({ page: 1, search: search.value })
}

const onSortChanged = async (sortData) => {
  sort.value.column = sortData.key
  sort.value.order = sortData.order
  await loadData({ column: sort.value.column, order: sort.value.order, page: 1 })
}

const updateVendor = async (data) => {
  const payload = { vendorId: data.id, column: data.field, value: data.value }
  const result = await vendors.updateVendor(payload)
  if (!result.success) notify({ title: 'error', text: 'message_error', color: 'danger' })
  notify({ title: 'success', text: 'message_update', color: 'success' })
}

const onDetails = (row) => {
  goTo({ name: 'rps-vendor-documents', params: { vendor: row.VendorId } })
}

onMounted(() => loadData())

</script>
